"use client";
import { jsx as t, jsxs as l } from "react/jsx-runtime";
import p from "next/image";
import n from "next/link";
import { memo as s } from "react";
import { Box as m } from "../../blocks/base/Base.js";
import { Tag as a } from "../tags/Tags.js";
import '../../assets/BlogList.css';const d = "_blog_list_1ydbp_1", y = "_blog_item_1ydbp_12", N = "_blog_item__cover_1ydbp_38", h = "_blog_item__title_1ydbp_43", f = "_blog_item__date_1ydbp_50", v = "_blog_item__content_1ydbp_59", x = "_blog_item__props_1ydbp_68", _ = {
  blog_list: d,
  blog_item: y,
  blog_item__cover: N,
  blog_item__title: h,
  blog_item__date: f,
  blog_item__content: v,
  blog_item__props: x
}, B = s(({ children: o }) => /* @__PURE__ */ t("div", { className: _.blog_list, children: o }));
B.displayName = "BlogList";
const I = s(
  ({ href: o, image: b, title: g, tags: e, date: c, ...r }) => /* @__PURE__ */ l(n, { href: o, className: _.blog_item, ...r, children: [
    /* @__PURE__ */ t(p, { ...b, className: _.blog_item__cover }),
    /* @__PURE__ */ l(m, { gap: 12, className: _.blog_item__content, children: [
      /* @__PURE__ */ t("span", { className: _.blog_item__title, children: g }),
      /* @__PURE__ */ l(m, { gap: 12, row: !0, className: _.blog_item__props, children: [
        e && e.length > 0 && /* @__PURE__ */ t(m, { gap: 8, row: !0, children: e.map((i) => /* @__PURE__ */ t(a, { text: i }, i)) }),
        /* @__PURE__ */ t("span", { className: _.blog_item__date, children: c })
      ] })
    ] })
  ] })
);
I.displayName = "BlogItem";
export {
  I as BlogItem,
  B as BlogList
};
